import React from 'react';
import styled from 'styled-components';
import ModalButtonPath from './ModalButtonPath';


export default function ModalPath(props) {

    return (
       
            props.showModal ? 
            <div>
                <ModalBackground />
                <Modal>
                    <ModalTitle>{props.title}</ModalTitle>
                        <ModalContentInner>{props.subtitle}</ModalContentInner>
                    <ModalButtonPath setShowModal={props.setShowModal} submitClick={props.submitClick} path={props.path}/>
                </Modal>
            </div>
            :
            null

        
    )
}



const Modal = styled.div`
    position: fixed;
    top:50%;
    left:50%;
    transform: translate(-50%,-50%);
    width: calc(100vw*(284/375));
    border-radius: calc(100vw*(10/375));
    background-color: #ffffff;
    z-index: 500;
`
const ModalTitle = styled.h3`
    font-size: calc(100vw*(18/375));
    font-weight: bold;
    letter-spacing: 0.25px;
    text-align: center;
    padding: calc(100vw*(20/375)) 0 calc(100vw*(12/375)) 0;
`
const ModalContentInner = styled.p`
    text-align: center;
    font-size: calc(100vw*(14/375));
    line-height: 1.43;
    letter-spacing: 0.2px;
    padding-bottom: calc(100vw*(16.5/375));
`

const ModalBackground = styled.div`
    position: fixed;
    top:0;
    left:0;
    width:100%;
    height:100%;
    background:rgba(0,0,0,0.6);
    z-index: 400;
`